import { render, staticRenderFns } from "./EditSociety.vue?vue&type=template&id=48c67d57&scoped=true&"
import script from "./EditSociety.vue?vue&type=script&lang=js&"
export * from "./EditSociety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c67d57",
  null
  
)

export default component.exports